/**
 * What the Messages tab shows in its red dot: nothing, or how many messages
 * are waiting.
 *
 * WHY A CAP. The dot sits on a 24 px icon in a 72 px tab (28/10/2026, design
 * review). Three digits pushed it over the label of the next tab; past nine,
 * "9+" says what matters, that there is a lot to read.
 *
 * Nothing at zero, and nothing for a count the store does not have yet: a dot
 * reading "0" would call for a tap that finds nothing new.
 */
export function whatTheMessagesTabSaysIsUnread(unread: number | null | undefined): string | null {
  if (!unread || unread < 1 || !Number.isFinite(unread)) {
    return null;
  }
  return unread > 9 ? '9+' : String(Math.floor(unread));
}
